import React from "react";
import styles from "./CustomerFavorites.module.css";
import { SERIES_DATA, TOP_RATED_PRODUCTS } from "../../data/furnitureData";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faStar,
  faMedal,
  faQuoteLeft,
} from "@fortawesome/free-solid-svg-icons";
type Product =
  | {
      productId: string;
      name: string;
      color: string;
      adjustable: string;
      backSupport: string;
      footRest: string;
    }
  | {
      productId: string;
      name: string;
      color: string;
      adjustable: string;
      backSupport: string;
      footRest?: undefined; // Explicitly mark as optional/undefined
    };

interface Series {
  id: string;
  title: string;
  folder: string;
  models: Product[];
}

interface PopularProduct {
  seriesId: string;
  productId: string;
  views: number;
  rating: number;
}
const CustomerFavorites = () => {
  const getProductDetails = (seriesId: string, productId: string) => {
    // Cast SERIES_DATA.find result to Series | undefined
    const series = (SERIES_DATA as Series[]).find((s) => s.id === seriesId);
    if (!series) return null;

    // Use type predicate to help TypeScript understand the find callback
    const product = series.models.find(
      (m): m is Product => m.productId === productId
    );
    if (!product) return null;

    return {
      ...product,
      seriesTitle: series.title,
      folder: series.folder,
    };
  };
  return (
    <section className={styles.favoritesSection}>
      <div className={styles.sectionHeader}>
        <h2 className={styles.sectionTitle}>
          <FontAwesomeIcon icon={faMedal} className={styles.medalIcon} />
          Customer Favorites
        </h2>
        <p className={styles.sectionSubtitle}>
          Top-rated commercial furniture loved by businesses nationwide
        </p>
      </div>

      <div className={styles.favoritesGrid}>
        {TOP_RATED_PRODUCTS.map((item, index) => {
          const product = getProductDetails(item.seriesId, item.productId);
          if (!product) return null;

          return (
            <div key={index} className={styles.favoriteCard}>
              <div className={styles.productHeader}>
                <div className={styles.productImageContainer}>
                  <img
                    src={`images/${product.folder}/${product.productId}.jpg`}
                    alt={product.productId}
                    className={styles.productImage}
                    loading="lazy"
                  />
                </div>
                <div className={styles.productInfo}>
                  <h3 className={styles.productTitle}>{product.name}</h3>
                  <p className={styles.productSeries}>{product.seriesTitle}</p>
                  <div className={styles.ratingContainer}>
                    <div className={styles.stars}>
                      {[...Array(5)].map((_, i) => (
                        <FontAwesomeIcon
                          key={i}
                          icon={faStar}
                          className={
                            i < Math.floor(item.rating)
                              ? styles.filledStar
                              : styles.star
                          }
                        />
                      ))}
                    </div>
                    <span className={styles.ratingText}>
                      {item.rating} ({item.reviews} reviews)
                    </span>
                  </div>
                </div>
              </div>

              <div className={styles.reviewContainer}>
                <FontAwesomeIcon
                  icon={faQuoteLeft}
                  className={styles.quoteIcon}
                  color="#000"
                />
                <p className={styles.reviewText}>{item.reviewExcerpt}</p>
              </div>

              <a
                href={`/series/${item.seriesId}#${item.productId}`}
                className={styles.viewButton}
              >
                View Product Details
              </a>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default CustomerFavorites;
